//仓储管理列表基本信息
import BASE_API from '@/api/dataBase';
export const searchColumns = (ctx) => {
  return [
    {
      prop: 'parkCompanyCode',
      name: '公司名称',
      type: 'select',
      options: ctx.companyList,
      value: 'personCompanyCode',
      label: 'personCompanyName',
      changeMethod: 'changeMethod',
      // disabled: !ctx.isCreate,
    },
    {
      prop: 'businessDepartmentCode',
      name: '部门',
      type: 'select',
      disabled: !ctx.queryData?.parkCompanyCode,
      options: ctx.departmentList,
      value: 'personDepartmentCode',
      label: 'personDepartmentName',
    },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'input',
    },
    {
      name: '合同状态',
      prop: 'contractStatus', //fixme
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'warehouseContractStatus' },
    },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'input',
    },
    {
      name: '合同状态',
      prop: 'contractStatus', //fixme
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'warehouseContractStatus' },
    },
    {
      name: '客户名称',
      prop: 'customerNameOne',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        partnerTypes: 'HZHB01',
        departmentCode: ctx.departmentCode,
        companyCode: ctx.companyCode,
      },
      changeMethod: 'changeMethod',
      isMultiple: true,
    },
    {
      name: '客户编码',
      prop: 'customerCodeOne',
      type: 'input',
    },
    {
      name: '开始日期',
      prop: 'dateStart',
      type: 'startDaterangePicker',
      format: 'yyyy-mm-dd',
    },
    {
      name: '结束日期',
      prop: 'dateEnd',
      type: 'endDaterangePicker',
      format: 'yyyy-mm-dd',
    },
    {
      name: '签约日期',
      prop: 'signingDate',
      type: 'date',
    },
    {
      name: '纸质合同号',
      prop: 'paperContractNo',
      type: 'input',
    },
    {
      name: '仓库名称',
      prop: 'warehouseName', //
      type: 'searchTableSpec',
      searchType: 'warehouse',
      extraData: {
        storageDepartmentCode: ctx.departmentCode,
        storageCompanyCode: ctx.companyCode,
      },
      changeMethod: 'changeMethod',
      isMultiple: true,
    },
    {
      name: '商品类型',
      prop: 'goodsTypeCode',
      type: 'select',
      options: ctx.goodsTypeList,
      changeMethod: 'changeMethod',
      multiple: true,
      labelKey: 'label',
      valueKey: 'value',
    },
    {
      name: '项目名称',
      prop: 'projectCode',
      type: 'searchTableSpec',
      searchType: 'warehouseContractListProject',
      changeMethod: 'changeMethod',
      isMultiple: true,
    },
  ];
};
